import styled from '@emotion/styled';
import { InfoIcon, WarningIcon } from '@/ui';
import { Color } from '../../styles/Color';

interface IAlertBannerIcon {
	type?: 'warning' | 'info';
}

export default function AlertBannerIcon({
	type = 'warning',
}: IAlertBannerIcon) {
	let IconComponent;

	switch (type) {
		// Change this based on whatever icons we need in the future
		case 'info':
			IconComponent = InfoIcon;
			break;
		default:
			IconComponent = WarningIcon;
			break;
	}

	return (
		<IconContainer>
			<IconComponent />{' '}
		</IconContainer>
	);
}

const IconContainer = styled.div`
	width: 32px;
	height: 32px;
	background-color: ${Color.Error};
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding-bottom: 0.25em;
	margin-right: 1em;

	svg {
		path {
			fill: ${Color.PrimaryWhite};
		}
	}
`;
